import React from "react";
import "../../css/quarterlyNewsletterSep.css";
import Heading from "../../components/Heading";
import Link from "gatsby-link";
import { PlogoSep } from "../../constant/newslette";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import MailForwardForm from "../../components/MailForwardForm";
import ShareLinks from "../../components/newsletterShareLinks";
import "../../css/pressview.css";
let duration = 400;

export class Testimonials extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
      showMailShareForm: false,
    };
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 2) {
        this.setState({
          slidesToShow: 2,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 3) {
        this.setState({
          slidesToShow: 3,
        });
      }
    }
  };

  toggleMailShareForm = () => {
    this.setState({ showMailShareForm: !this.state.showMailShareForm });
  };

  render() {
    const { defaultStyle, showMailShareForm } = this.state;
    const { location } = this.props;
    return (
      <div>
        
        <ContentPage>
          <Meta
            title="Winpe Testimonials"
            image={
              "https://winpeforum.com/assets/elements/newsletter_April_to_june.jpg"
            }
            description="With the Winpe mentoring programme, I had the opportunity to interact with and learn from fabulous leaders, and the other wonderful women in private equity who were part..."
            location={location}
          />
          <div className="section__content" style={defaultStyle}>
            <div className="toastshine_wrapper quarterlyNewsletteSep_wrapper">
              <div className="toastshine_section quarterlyNewsletteSep_section">
                <div className="quarterlyNewsletteSep_content">
                <br/> <br/>
                    
                    <div className="gellery_section">
                <div className="gellery_content">
                  <div className="gellery_heading">
                    <div className="">
                      <Heading title="Testimonials" />
                    </div>
                  </div> <br/> <br/>
                  <div class="container">
                 <div class="row">
                 <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/6K-6ZQ88cU4"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/YVlfZPUWA1c"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
                 <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/TCYm0BWVBRk"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/HM2K8Yx4TW4"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/M5BKEcCowCE"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/g7LkMHvd5HM"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/wZJuVjliZvY"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/ccokHV0-8Hg"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/QC2AEKZqgpk"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/dgPZoow-EaI"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/F_7gXm5HfDA"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/sNSZlgm3Obo"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/LyaXoct1Jh8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/zTHEb8u6CNs"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>





              
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/v0l2TezOMaI"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/K5uf3XaIjR4"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/zFQCCnXF0CE"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/gbovAx5QZSo"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/giMMkFSNgMI"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/_w6Q40cKjiI"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/ZrpKj6ufyw8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/RRAPyZNrHI0"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/Lf9F42NJuwg"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/cg6NMowF6wo"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/s_ZI-hAXnWY"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/koW-lF-c4AM"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/eytm7T1glrs"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/vmhZ8nUI_KQ"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/8qo5NMumCPA"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/GySz-Ue7kzQ"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/nrdBJJyt-yE"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/IFwtlSrfYTU"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/iCoNBYX3Ve8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/Qcf2_2mq-fk"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/EBTNKNOywMs"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/VXolGylO_m8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/DKdtucNR6O8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/KPYMeBg9ctA"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/_Jr7Xf3NY20"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/Ug0vlB13X7Y"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/KKlgBPpA-B8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
                 <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/yjOv3tkZF3Q"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/_LpHM2iTqJo"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/k-4Z45aXkf0"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
                     
                      
                 <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/EmDj48MmRH8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/s2hWFFnWfi8"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/sBRUGCVuVJY"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
                     
                 <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/QpIa8VPBoMk"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/KyHDeSkEvKE"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/yqeHOorgZks"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
                      
                 <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/gEb1SWYj95I"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               <div class="col-md-4" style={{paddingBottom: "30px"}}>
                  <iframe
                        width="100%" height="200"
                        src="https://www.youtube.com/embed/vatRMSNObVY"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen 
                        ></iframe>
               </div>
               
                     </div>
                    <br/> <br/>
                    <div class="text" style={{fontSize:'18px', color: '#22316B', textAlign: 'justify'}}>
"Winpe brings together a select group of female investment professionals, aspiring female PE/VCs and founders to promote relationships and professional development through meaningful networking events/mentorship programs designed to further their careers in the PE/VC sector. In the spirit of friendship and sisterhood Winpe offers opportunities to build and foster mutually beneficial relationships that enrich its member’s careers and support leadership and advancement.
<br/>
The recent event attended by me in Bengaluru was highly engaging and well-organized. It was an amazing experience to connect with inspiring women in the investment ecosystem. The event was a good combination of engaging sessions, networking, and fun. I would recommend Winpe to every female investment professional and aspiring female investment professional and look forward to more events organized by Winpe.
<br/>
Kudos to the Winpe team and keep up with good work.
"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Kiran Sharma, Senior Analyst, Accion Global Investments
</span>
</div>         
<br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"With the Winpe mentoring programme, I had the opportunity to interact with and learn from fabulous leaders, and the other wonderful women in private equity who were part of my cohort. The highlight of the programme was the one-on-one mentoring conversations with my mentor, Soumya Rajan, where the sole agenda was my development. Soumya brought her perspective to my context and gave generously of her time, connections and insight to help me grow. I am very grateful to Soumya for being willing to share and build me up. Many thanks to Soumya's assistant, Allison, who was very thorough about setting up our meetings despite Soumya's busy schedule. Hurrah to the teams at Winpe and Russell Reynolds for starting and running this timely, thoughtful and well-run programme. "
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Jolly Abraham, Director, True North</span>
</div>         
<br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"As my fellow mentees and I graduate as the first cohort of the mentorship programme designed by Winpe in collaboration with Russel Reynolds, I am not alone in feeling gratitude for the fantastic platform provided by this programme. The first of its kind programme for women from the PE space, it has been a journey of learning from the experiences of some truly remarkable leaders that has inspired us to strive for delivering higher impact and emboldened us to go beyond our comfort zone. Despite it being a year of virtual connections and conversations, the programme strove to make these mentor-mentee relationships deliver great value. What I take back from this platform is an opportunity to not just build a long lasting relationship of guidance with my mentor but also be associated with a group of exceptional women leaders. Truly grateful to Winpe for this."
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Asha Krishnan, Operating Director, General Atlantic
</span>
</div>    <br/> <br/>  
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Winpe's mentoring program was highly valuable for me – I entered the same with a very open mind and many aspects to learn on. I am thankful to have found a mentor who was very experienced and was willing to share her thoughts about a variety of things, very openly with me. My mentor and I, both were very serious about this program and used the opportunity to set objectives ahead of our conversations.  This really helped me maximise my learnings. It wasn’t all serious though - many similarities in our journey made us connect a lot more and there was a personal bonding that got created. I would highly recommend the program to the professionals in the investing community.
"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Anshul Jain, Managing Director, Lighthouse Advisors
</span>
</div> <br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Winpe’s mentoring programme provided me with a valuable opportunity to network and openly exchange ideas. It made me think and set goals for myself which I would have not otherwise considered. I am thankful to my mentor for candidly sharing his views, suggestions and experiences with me and for encouraging me to think beyond my set frontiers. Our conversations have helped me develop both on a professional and personal front. I look forward to continuing leveraging the relationships built during the programme.
"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Anahita Medhora,  Vice President, Everstone Capital
</span>
</div> <br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"I look forward to being a part of the Winpe Mentorship Program and interacting and learning from inspiring women to help me build the tools necessary for the next phase of my career."
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Pallavi Satpute, Counsel, AZB & Partners
</span>
</div> <br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Thank you, Winpe, for giving me access to your stellar network of industry professionals. Satish helped to break down the different avenues in investing space, and delved further into my area of interest. He also helped me understand how to structure thought processes when approaching investment decisions in case studies.
 <br/><br/>
 These practical insights are hard to come by. Grateful to the entire team for making such opportunities available to people looking to make a career in investing.
 "
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Shruti Mimani
</span>
</div> <br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"The conversation was very nice and insightful. We spoke about learnings and qualities that need to be inculcated and are always in demand - be it intellectual curiosity or being a collaborative team player. And a major takeaway was to take risks in order to propel further in your career.  Thank you for arranging this call."
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Young investment banker and Aspiring investor
</span>
</div> <br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Shoutout to Winpe Forum for giving me the opportunity to interact with Capital Markets expert Bhavna Thakur! The 1:1 session was extremely insightful. Great initiative and looking forward to more such opportunities! This was great…"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-Shriya Bahul, IFC, Investment Analyst 

</span>
</div>    
<br/> <br/>
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"It was an amazing discussion, as I got the chance to speak to someone who joined the investing space while it was pretty new in India. 
<br/>
Thank you Sakshi Chopra and Winpe for this session."

<br/> 
<span style={{color:'#BF2026', fontWeight:'700' }}>-
Ritika Sharma, Management Trainee: Product Manager, Consumer Financial Services, Freecharge 


</span>
</div> 
<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
" Incredibly insightful, many thanks!"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Shivani Kabra, Anand & Anand & Khimani, Associate  
</span>
</div> <br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Thanks a lot, amazing bootcamp"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Shikha Gupta, Barclays, Analyst 
</span>
</div>  <br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"This was a very insightful, valuable session - appreciate the panelists for taking out their time - and also for my CV review :) And big thanks to Winpe for hosting this :)"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Dhwani Nanavati, Leap Finance, Business Associate, Founder’s Office
</span>
</div>  

<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"thank you Winpe for the lovely session"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Harini Shrinivasan , Catalyst Trusteeship Limited, VP Legal 
</span>
</div>  
<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"This was an amazing session! Hope we see more of impact investing sessions soon :)"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Shivangi Saxena, World Bank, Consultant
</span>
</div>  

<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Very authentic & great session!"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Vidisha Gupta, Bain, Associate 
</span>
</div>  

<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Thank you for this incredibly insightful session!"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Moksha Miss, Innoterra (formerly Pioneering Ventures), Associate
</span>
</div>  

<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Thanks, very helpful!"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Anisha Belur, Bain And Company, Analyst 
</span>
</div>  

<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Thank you Winpe team for the session!"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Heena Kedia, CA Divyesh J Shah & Associates , CA
</span>
</div>  


<br/> <br/> 
<div class="text" style={{fontSize:'18px', color: '#22316B' , textAlign: 'justify'}}>
"Thank you for the session!"
<br/> 
<span style={{color:'#BF2026', fontWeight:'700'}}>-
Shubhranka Mondal, KPMG, Consultant
</span>
</div>  









                     </div>
                </div>
              </div>
              <br/> <br/>   
   </div>
 
   </div> </div>   
           
          </div>
        </ContentPage>
      </div>
    );
  }
}

Testimonials.propTypes = {
  location: PropTypes.object,
};

export default Testimonials;



// WEBPACK FOOTER //
// ./src/pages/testimonials/index.js